import ko from "knockout";
import componentCache from "flow/utils/componentCache";
import { Dictionary } from "flow/api/types";
import { MaybeObservable } from "flow/interfaces/MaybeObservable";
import viewHtml from "./crossModuleComponent.html";

export interface ICrossModuleParams {
    id: MaybeObservable<string>;
    viewContext: MaybeObservable<Dictionary>;
}

ko.components.register("cross-module-component", {
    viewModel: function (params: ICrossModuleParams) {
        const id = ko.utils.unwrapObservable(params.id);

        if (!id) {
            throw new Error("CrossModuleComponent: You must specify component id.");
        }

        this.component = componentCache.getComponentById(id);

        if (!this.component) {
            throw new Error("Unknow component: " + id);
        }

        this.component.safeLoad().done(() => {
            this.component.activate(ko.utils.unwrapObservable(params.viewContext));
            this.component.onShow();
        });

        this.dispose = () => {
            this.component.onHide();
            if (this.component.manifest.reuseInstance === false) {
                this.component.onDestroy();
            }
        };
    },
    template: viewHtml
});
